module.exports = __webpack_public_path__ + "img/IT0001407571472.3168ad38.png";